"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _react2 = _interopRequireDefault(require("@fullcalendar/react"));

var _daygrid = _interopRequireDefault(require("@fullcalendar/daygrid"));

var _timegrid = _interopRequireDefault(require("@fullcalendar/timegrid"));

var _interaction = _interopRequireDefault(require("@fullcalendar/interaction"));

var _list = _interopRequireDefault(require("@fullcalendar/list"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _availability = require("../../redux/availabilty/availability.types");

var _reselect = require("reselect");

var _AvailabilityModal = _interopRequireDefault(require("./AvailabilityModal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const initialState = {
  selectedAvailability: undefined,
  availabilityEvents: []
};

class AppointmentCalendar extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = _lodash.default.clone(initialState);
    this.calendar = /*#__PURE__*/_react.default.createRef();

    this.refreshCalendar = () => {
      var _a, _b, _c, _d;

      if ((_a = this.calendar) === null || _a === void 0 ? void 0 : _a.current) {
        const startMoment = (0, _moment.default)((_c = (_b = this.calendar) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.getApi().getCurrentData().dateProfile.currentRange.start);
        const getAvailabilitiesQueryParameters = {
          startDate: startMoment.toDate()
        };
        this.props.getAvailabilities(getAvailabilitiesQueryParameters);

        if ((_d = this.props.availabilities) === null || _d === void 0 ? void 0 : _d.length) {
          this.setState({
            availabilityEvents: this.props.availabilities.map(a => {
              var _a;

              return {
                id: (_a = a.id) === null || _a === void 0 ? void 0 : _a.toString(),
                userId: a.userId,
                title: a.username,
                start: a.startDate,
                end: a.endDate
              };
            })
          });
        }
      }
    };

    this.selectAvailability = id => {
      const {
        studyId,
        history
      } = this.props;
      history.push(`/study/${studyId}/appointments/availability/edit/${id}`);
    };

    this.handleDateSelect = selectInfo => {
      const selectedAvailability = {
        startDate: selectInfo.start,
        endDate: selectInfo.end
      };
      this.setState({
        selectedAvailability,
        removeEvent: () => selectInfo.view.calendar.unselect()
      });
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/appointments/availability/new`);
    };

    this.handleEventClick = clickInfo => {
      this.selectAvailability(clickInfo.event.id);
      this.setState({
        removeEvent: () => clickInfo.event.remove()
      });
    };

    this.saveAvailability = availabilityToSave => {
      if (this.state.removeEvent) {
        this.state.removeEvent();
      }

      this.props.createAvailability(availabilityToSave);
    };

    this.handleEventDrop = changeInfo => {
      _message2.default.error('Cannot reschedule availabilities. You must delete existing and create a new one.');

      changeInfo.revert();
    };

    this.handleEventResize = changeInfo => {
      _message2.default.error('Cannot reschedule availabilities. You must delete existing and create a new one.');

      changeInfo.revert();
    };

    this.newAvailability = () => {
      const {
        history,
        studyId
      } = this.props;
      history.push(`/study/${studyId}/appointments/availability/new`);
    };
  }

  componentDidMount() {
    this.refreshCalendar();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    var _a;

    const {
      requestedAppointmentTab,
      selectedAvailabilityId,
      availabilities
    } = this.props;

    if (requestedAppointmentTab === 'availability' && selectedAvailabilityId && availabilities) {
      const idInt = parseInt(selectedAvailabilityId);

      if (idInt !== ((_a = prevState.selectedAvailability) === null || _a === void 0 ? void 0 : _a.id)) {
        const selectedAvailability = _lodash.default.find(availabilities, a => a.id === idInt);

        this.setState({
          selectedAvailability
        });
      }
    }

    if ((availabilities === null || availabilities === void 0 ? void 0 : availabilities.length) && !_lodash.default.isEqual(prevProps.availabilities, availabilities)) {
      this.setState({
        availabilityEvents: availabilities.map(a => {
          var _a;

          return {
            id: (_a = a.id) === null || _a === void 0 ? void 0 : _a.toString(),
            userId: a.userId,
            title: a.username,
            start: a.startDate,
            end: a.endDate
          };
        })
      });
    }
  }

  render() {
    const {
      selectedAvailability,
      availabilityEvents,
      removeEvent
    } = this.state;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, selectedAvailability && /*#__PURE__*/_react.default.createElement(_AvailabilityModal.default, {
      selectedAvailability: selectedAvailability,
      saveAvailability: this.saveAvailability,
      removeEvent: removeEvent
    }), /*#__PURE__*/_react.default.createElement(_react2.default, {
      ref: this.calendar,
      unselectAuto: false,
      plugins: [_daygrid.default, _timegrid.default, _interaction.default, _list.default],
      customButtons: {
        new: {
          text: 'new',
          click: this.newAvailability
        }
      },
      headerToolbar: {
        left: 'prev,next today',
        center: 'title',
        right: 'new'
      },
      initialView: "timeGridWeek",
      events: availabilityEvents,
      editable: true,
      allDaySlot: false,
      selectable: true,
      selectMirror: true,
      dayMaxEvents: true,
      weekends: true,
      select: this.handleDateSelect,
      eventClick: this.handleEventClick,
      eventDrop: this.handleEventDrop,
      eventResize: this.handleEventResize
    }));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  selectedAvailabilityId: selectors.getUrlNewOrEditId,
  requestedAppointmentTab: selectors.getUrlRouteSubpage,
  studyId: selectors.getRequestedStudyId,
  availabilities: selectors.getAvailabilities
});

const mapDispatchToProps = dispatch => {
  return {
    getAvailabilities: params => dispatch(_availability.getAvailabilitiesAsync.request(params)),
    createAvailability: a => dispatch(_availability.createAvailabilityAsync.request(a))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _reactRouterDom.withRouter)(AppointmentCalendar));

exports.default = _default;